<template>
  <div class="drawer">
    <div class="reports-drawer">
      <div
        id="ReportsDrawer-Overlay"
        class="drawer__overlay"
        @click="onClickCloseReportsDrawer()"
      ></div>
      <div
        class="drawer__inner"
        role="dialog"
        aria-modal="true"
        aria-label="Report"
        tabindex="-1"
      >
        <div class="drawer__header">
          <div class="drawer__heading inner-title">Report Recenti</div>
          <div class="inner-actions">
            <b-button
              type="button"
              variant="lisaweb"
              size="sm"
              style="height: 22px !important; padding: 0 15px !important"
              @click.stop="onRefreshContent()"
              title="Refresh"
              ref="refreshReportTable"
              ><base-icon
                name="reload"
                width="14"
                height="14"
              />Ricarica</b-button
            >
            <button
              class="drawer__close"
              type="button"
              @click="onClickCloseReportsDrawer()"
              aria-label="Chiudi"
            >
              <base-icon name="close" width="12" height="12" />
            </button>
          </div>
        </div>
        <div
          :class="`reports-drawer-items${
            !reports || !reports.length ? ' is-empty' : ''
          }`"
        >
          <template v-if="reports && reports.length">
            <b-overlay :show="isLoadingReports">
              <div v-show="!isLoadingReports">
                <div
                  class="report-item"
                  v-for="(item, index) in reports"
                  :key="item.id || index"
                >
                  <div v-if="isValidItem(item)" class="reports-item__inner">
                    <p v-if="item.report" class="reports-item__title">
                      <strong>
                        {{ item.report.code }}
                        -
                        {{ item.report.title }}
                      </strong>
                    </p>
                    <div class="custom-grid-wrapper">
                      <template v-if="item.format">
                        <strong>Formato</strong>
                        <span class="report-item__type">
                          {{ item.format }}
                        </span>
                      </template>
                      <template
                        v-if="item.status_report && item.status_report.text"
                      >
                        <strong>Stato</strong>
                        <span class="report-item__type">
                          {{ item.status_report.text }}
                        </span>
                      </template>
                      <template v-if="item.is_ready && item.is_ready.text">
                        <strong>Pronto</strong>
                        <span class="report-item__type">
                          {{ item.is_ready.text }}
                        </span>
                      </template>
                      <template v-if="item.user_id">
                        <strong>Utente</strong>
                        <span class="report-item__users">
                          {{ getOwner(item.user_id) }}
                        </span>
                      </template>
                      <template v-if="item.created_date">
                        <strong>Data creazione</strong>
                        <span class="report-item__start">
                          {{
                            moment(item.created_date).format(
                              "DD/MM/YYYY HH:mm:ss",
                            )
                          }}
                        </span>
                      </template>
                    </div>
                    <div class="report-item__actions">
                      <b-button
                        v-if="item.is_ready && item.is_ready.value"
                        size="sm"
                        class="btn--transparent"
                        style="
                          height: 40px;
                          width: 40px;
                          padding: 0.2rem;
                          border: none;
                          border-radius: 99rem;
                        "
                        :title="`${
                          item.is_ready.value === 'Y' ? 'Download' : 'In Attesa'
                        }`"
                        :disabled="item.is_ready.value === 'N'"
                        @click.stop="downloadReport(item)"
                      >
                        <base-icon name="download" width="22"></base-icon>
                      </b-button>
                      <b-button
                        v-if="item.user_id && item.id"
                        size="sm"
                        class="btn-reset btn--transparent"
                        style="
                          height: 40px;
                          width: 40px;
                          padding: 0.2rem;
                          border: none;
                          border-radius: 99rem;
                        "
                        title="Elimina report"
                        :disabled="!isDeletable(item.user_id)"
                        @click.stop="deleteReport(item.id)"
                      >
                        <base-icon name="trash" width="22"></base-icon>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <template #overlay>
                <div class="text-center">
                  <div class="custom-loader"></div>
                  <p class="loading-text">Operazione in corso...</p>
                </div>
              </template>
            </b-overlay>
          </template>
          <template v-else
            ><p><i>Non ci sono report</i></p></template
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import BaseIcon from "@/components/BaseIcon";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters } from "vuex";
import moment from "moment";
moment.locale("it");
export default {
  mixins: [DocumentsMixin],
  data() {
    return {
      repository: "generated_report",
    };
  },
  props: {
    reports: {
      type: Array,
      default() {
        return [];
      },
    },
    isLoadingReports: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIcon,
  },
  computed: {},
  watch: {
    isLoadingReports: function (newVal, oldVal) {
      // watch it
      console.log(
        `Prop "isLoadingReports" changed: , ${newVal}, | was: , ${oldVal}`,
      );
    },
  },
  methods: {
    moment,
    downloadReport(item) {
      const document = item?.documents?.[0];
      if (!document) {
        this.$showSnackbar({
          preset: "error",
          text: "C'è stato un errore nel recuperare il file. Riprovare più tardi.",
        });
        return;
      }
      this.downloadDocument(document);
    },
    isValidItem(item) {
      return (
        item &&
        typeof item === "object" &&
        !Array.isArray(item) &&
        Object.keys(item).length > 0
      );
    },
    isDeletable(id) {
      const users = this.getUsers && this.getUsers();
      if (!Array.isArray(users)) return false;
      const user = users.find((u) => u.value === id);
      const currentUserId = this.$store?.state?.auth?.user?.id;
      return !!(user && currentUserId && user.value === currentUserId);
    },
    getOwner(id) {
      const users = this.getUsers && this.getUsers();
      if (!Array.isArray(users)) return "";
      const user = users.find((u) => u.value === id);
      return user && user.username ? user.username : "";
    },
    onRefreshContent() {
      this.$emit("reloadReportsDrawer");
      console.log("$root - reloadReportsTable");
      this.$root.$emit("reloadReportsTable");
    },
    deleteReport(id) {
      if (!id) return;
      this.$emit("isLoadingReportsTrue");
      console.log("id", id);
      const Repo = RepositoryFactory.get("generated_report");
      Repo.destroy(id)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: "Report cancellato",
          });
        })
        .catch((error) => {
          const errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.$emit("reloadReportsDrawer");
          console.log("$root - reloadReportsTable");
          this.$root.$emit("reloadReportsTable");
        });
    },
    onClickCloseReportsDrawer() {
      this.$emit("closeReportsDrawer");
    },
    ...mapGetters("auth", {
      getUsers: "users",
    }),
  },
  beforeMount() {},
};
</script>
<style lang="scss" scoped>
#app.drawer-reports--open .drawer {
  visibility: visible;
}
#app.drawer-reports--open .drawer__inner {
  transform: translateX(0);
}
#app.drawer-reports--open .drawer__overlay {
  opacity: 1;
}
.drawer {
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  visibility: hidden;
  background: 0;
  transition: visibility 200ms ease;
}
.drawer.is-empty {
  display: grid;
  grid-template-rows: 1fr;
  align-items: center;
  padding: 0;
}
.drawer__overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(18, 18, 18, 0.5);
  opacity: 0;
  transition: all 0.3s ease-in-out;
}
.drawer__overlay:empty {
  display: block;
}
.drawer__inner {
  width: 40vw;
  max-width: 500px;
  height: 100vh;
  max-height: 100vh;
  margin-top: 0;
  border: 0;
  background: #fff;
  box-shadow: -1px 0 0 0 var(--gray-100);
  transform: translateX(100%);
  transition: all 0.3s ease-in-out;
}
.drawer__close {
  border: 0;
  background: 0;
  position: relative;
  top: -2px;
}
.drawer__header {
  border-bottom: 1px solid var(--gray-100);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  font-size: var(--font-size-lg);
  font-weight: 500;
}
.drawer__header .inner-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.reports-drawer-items.is-empty {
  height: 100%;
  padding: 0 1.5rem;
  background-color: rgb(var(--color-background));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.reports-drawer-items .b-overlay-wrap[aria-busy="true"] {
  height: calc(100dvh - 59px - 20px - 20px);
}
.reports-drawer-items.is-empty > p {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  margin: 0;
}
.drawer .reports-drawer-items:not(.is-empty) {
  overflow-y: scroll;
  scrollbar-gutter: stable;
  height: calc(100vh - 59px);
  padding: 20px;
}
.drawer .report-item {
  padding-bottom: 20px;
}
.drawer .report-item ~ .report-item {
  padding-top: 20px;
}
.drawer div > .report-item:nth-of-type(even) {
  background: var(--gray-50);
  box-shadow: 0 0 0 100vmax var(--gray-50);
  clip-path: inset(0 -100vmax);
}
.drawer .report-item .report-item__title,
.drawer .report-item .report-item__desc {
  margin-bottom: 10px;
}
.drawer .report-item:has(.report-item__desc) .report-item__title {
  margin-bottom: 0;
}
.drawer .report-item .report-item__title {
  grid-area: 1 / 1 / 2 / 3;
}
.drawer .report-item .report-item__desc {
  grid-area: 2 / 1 / 3 / 3;
}
.drawer .report-item .custom-grid-wrapper {
  grid-template-columns: 125px minmax(auto, max-content);
  grid-row-gap: 5px;
  grid-column-gap: 18px;
  grid-area: 2 / 1 / 3 / 2;
}
.drawer .report-item .report-item__desc ~ .custom-grid-wrapper {
  grid-area: 3 / 1 / 4 / 2;
}
.drawer .report-item__inner {
  display: grid;
  grid-template-columns: auto 38px;
  grid-auto-flow: row;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}
.drawer .report-item__actions {
  display: flex;
  align-items: center;
  gap: 15px;
  grid-area: 2 / 2 / 3 / 3;
  align-self: flex-end;
  justify-self: flex-end;
}
.drawer .report-item__desc ~ .report-item__actions {
  grid-area: 3 / 2 / 4 / 3;
}
.drawer .report-item__users ul {
  padding-left: 16px;
  margin: 0;
}
@media (hover: none) and (pointer: coarse) {
  .drawer .reports-drawer-items:not(.is-empty) {
    -webkit-overflow-scrolling: touch;
  }
}
</style>
<style lang="scss">
.reports-drawer-items
  .b-overlay-wrap[aria-busy="true"]
  .b-overlay.position-absolute {
  left: -20px !important;
  top: -20px !important;
  width: calc(100% + 40px) !important;
}
.reports-drawer-items:has(.b-overlay-wrap[aria-busy="true"]) {
  overflow: hidden !important;
}
</style>
